<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm6 md6 lg6>
        <v-card >
          <v-toolbar dense flat >
            <v-toolbar-title>Вход в систему</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            {{errorMessage}}
            <v-form v-model="valid" ref="form">
              <v-text-field prepend-icon="person"
                v-model = "credentials.username"
                label="Эл. почта"
                :rules="emailRules"
                type="text"
                clearable
              ></v-text-field>
              <v-text-field prepend-icon="lock" v-model = "credentials.password" label="Пароль" type="password"
              :rules="passwordRules"
              clearable
              ></v-text-field>
              Вы еще не зарегистрированы?
              <router-link to="/register">Регистрируйтесь</router-link>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn block :disabled="!valid"
              color="primary" @click="login" >Войти</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import formats from '../../api/formats'
  export default {
    data: () => ({
      valid: false,
      isRegister: false,
      credentials: {
        username: '',
        password: ''
      },
      emailRules: [
        v => !!v || 'Введите адрес электронной почты, для идентификации в системе',
        v => formats.isEmail(v) || 'Неверный формат эл. почты'
      ],
      passwordRules: [
      ],
      errorMessage: ''
    }),
    mounted () {
      this.credentials.username = this.$store.getters.getLastLogin(true)
      if (this.credentials.username.includes('@dealger.ru')) {
        this.credentials.password = 'pass1'
      }
    },
    methods: {
      login () {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('login', this.credentials)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?26a28bf5